import React from 'react';

import Layout from '@src/layouts';
import { CategoryBrowser } from '@commons/category-browser/CategoryBrowser';
import SEO from '@commons/SEO';
import { PreviousBlogPostsSection } from '@pages-impl/blog';
import { DesktopHeaderLayoutA, MobileHeaderLayoutA } from '@src/components/commons';

import { defaultProps } from './payload';
import { blogHeaderProps } from '@pages-impl/blog/payload';
import featuredImage from '@images/header-images/featured_image_og_codilime_blog.jpg';

export function BlogMain(props) {
  const currentPath = props.location.pathname;
  return (
    <Layout {...props}>
      <SEO
        title={props.seoTitle || defaultProps.seoTitle}
        description={props.seoDescription || defaultProps.seoDescription}
        featuredImage={props.featuredImage || featuredImage}
      />
      <DesktopHeaderLayoutA {...blogHeaderProps} />
      <MobileHeaderLayoutA {...blogHeaderProps} />
      {props.location.pathname === '/blog/' && <CategoryBrowser />}
      <PreviousBlogPostsSection location={props.location} />
      {props.location.pathname !== '/blog/' && <CategoryBrowser isBottom currentPath={currentPath} />}
    </Layout>
  );
}
